module.exports = __webpack_public_path__ + "static/media/sharingPlaceholder.de6018f1.jpg";